import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'
import { OnDestroy } from '@angular/core';

export interface IDivulgacaoFornecedor extends IDataModel {
    fornecedor?: number,
    gostou?: number,
    ident?:string,
    pagina?: string,
}

export class DivulgacaoFornecedor 
   extends DataModel<IDivulgacaoFornecedor> 
   implements OnDestroy{
    lista = [];
    constructor(private db: AngularFirestore) {
        super(db, 'analytics');
    }

    addDivulgacao(fornecedor: number, pagina: string, gostou: number) {
        this.addAnalytics(fornecedor,'publicidade',pagina,gostou);
    }

    addAnalytics(fornecedor: number,ident:string, pagina: string, gostou: number) {
        let it: IDivulgacaoFornecedor = {};
        it.fornecedor = fornecedor;
        it.gostou = gostou;
        it.pagina = pagina;
        it.ident = ident;
        let rt = null;
        this.lista.forEach(element => {
            if (element.fornecedor == fornecedor && (element.ident==ident)) {
                element.gostou += gostou;
                rt = element;
            }
        });
        if (rt == null) this.lista.push(it);
        this.postList();
    }


  postList(){
      if (this.lista.length>0)
         this.addList(this.lista);
         this.lista = [];   
  }
  ngOnDestroy(){
      this.postList();
  }
}
